import { Injectable, type Signal, signal } from '@angular/core';

import { APP_SECTION_ID, type AppSectionId } from '@efficiently/client-core-routing';

import { ProjectSurfaceAccessService } from './project-surface-access.service';

const PROJECT_SURFACE_IDS: ReadonlySet<AppSectionId> = new Set([
	APP_SECTION_ID.DESIGN,
	APP_SECTION_ID.BUILD,
	APP_SECTION_ID.CLIENT_PORTAL,
	APP_SECTION_ID.SUPPLY,
]);

@Injectable()
export class DefaultProjectSurfaceAccessService extends ProjectSurfaceAccessService {
	// TODO(CLR-530): narrow to the surfaces the permissions of the person's stakeholder role grant on the project
	public override readonly grantedSurfaceIds: Signal<ReadonlySet<AppSectionId>> =
		signal(PROJECT_SURFACE_IDS).asReadonly();
}
